<template>
  <div>
    <q-dialog v-model="dialogSource.isOpen">
      <q-card class="card-vue" style="width: 600px">
        <q-card-actions>
          <span class="text-h6"> 列设置</span>
        </q-card-actions>
        <div class="p10">
          <q-table :rows="tableSource.columns" :key="tableKey" ref="qTable" row-key="id" id="sortColTable" class="my-fixed-heade-table table-border layout-table" :style="'height:450px'" square flat color="primary" virtual-scroll
                   v-model:pagination="pagination" hide-pagination
                   no-data-label="无数据" :dense="true" :columns="columns">
            <template v-slot:body-cell-check="props">
              <q-td>
                <q-checkbox size="xs" v-model="props.row.check" @update:model-value="checkChange"/>
              </q-td>
            </template>
            <template v-slot:body-cell-fixed="props">
              <q-td style="text-align: right">
                <q-select style="width: 100px" dense outlined clearable v-model="props.row.fixed" @update:model-value="changeFixed" :options="[{ label: '不固定',value: ''},{label: '左',value: 'left'},{label: '右',value: 'right'}]" emit-value map-options>
                </q-select>
              </q-td>
            </template>
          </q-table>
        </div>
        <q-card-actions align="right">
<!--          <q-btn label="取消" size='9px'/>-->
          <q-btn color="primary" size='9px' label="关闭" @click="closeFun" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import {getRandomString } from '@/tools/utils';
import {toRef, inject, computed, watch, ref, nextTick} from 'vue'
import { useStore } from 'vuex';
import sortablejs from 'sortablejs';
import {setColStyle} from "../../../tools/table-drag";
export default {
  name: "set-col-diaog",
  props:['tableSource'],
  setup(props,context){
    let dialogSource = ref({
      isOpen:false,
    });
    let tableKey = ref(getRandomString(8))
    let tableSource = toRef(props.tableSource);
    let qTable = ref();
    let pagination=ref({rowsPerPage: 0});
    let columns = ref([
      {name: 'label',field: 'label',label: '列名',headerStyle: 'min-width: 120px',align: 'left',},
      {name: 'check',field: 'check',label: '显示隐藏',headerStyle: 'min-width: 60px',align: 'center',},
      {name: 'fixed',field: 'fixed',label: '列固定',headerStyle: 'min-width: 60px',align: 'center',},
    ]);
    let sortableDom = ref(null);
    let openFun = ()=>{
      dialogSource.value.isOpen = true;
      setColSort();
    }
    let setColSort = ()=>{
      nextTick(()=>{
        let myDom = document.getElementById('sortColTable').getElementsByClassName('q-virtual-scroll__content')[0]
        sortableDom.value = sortablejs.create(myDom, {
          ghostClass: 'sortable-ghost',
          animation: 60,
          setData(dataTransfer) {
          },
          onEnd: (e) => {
            const { oldIndex, newIndex } = e
            let targetRow = tableSource.value.columns.splice(oldIndex, 1)[0];
            tableSource.value.columns.splice(newIndex, 0, targetRow);
            tableKey.value = getRandomString(8);
            nextTick(()=>{
              setColStyle({cols:tableSource.value.columns,leftYl:40});
              setColSort();
            })
          },
        });
      })
    }
    let checkChange = ()=>{
      setColStyle({cols:tableSource.value.columns,leftYl:48});
    }
    let changeFixed = ()=>{
      setColStyle({cols:tableSource.value.columns,leftYl:48});
    }
    let closeFun = ()=>{
      dialogSource.value.isOpen = false;
    }
    return{
      qTable,
      dialogSource,
      openFun,
      closeFun,
      columns,
      pagination,
      tableKey,
      changeFixed,
      checkChange
    }
  }
}
</script>

<style lang="scss" scoped>
.table-border{
  ::v-deep td {
    overflow: hidden;
    //word-wrap: break-word !important;
    //white-space: normal;
  }
  ::v-deep .q-table__middle {
    border: 1px solid #e0e0e0 !important;
  }
  ::v-deep .q-table{
    border-bottom:1px solid #e0e0e0;
  }
  ::v-deep .q-table thead tr th{
    background-color: #E2E7EF;
    text-align: center;
  }
  ::v-deep.q-table--dense .q-table__top {
    padding: 6px 0px;
  }
  ::v-deep .q-table--dense .q-table td:first-child {
    padding-left: 16px;
    background-color: white;
  }
  ::v-deep .q-table tbody tr td:first-child{
    background-color: white;
  }
}

::v-deep .q-toolbar {
  min-height: 33px;
}

::v-deep .q-btn .q-icon {
  font-size: 22px !important;
}
::v-deep.my-select .q-field__native{
  min-height: 0px;
}
.btn-checked{
  border: 1px solid;
}
.serch-icon{
  cursor: pointer;
}
.my-text-btn:hover{
  color: #42A5F5;
}
</style>
